// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e32e5fd9","455":"f8966d7b","977":"bc1c4799"}[chunkId] + ".chunk.js";
};